export default __webpack_public_path__ + "static/media/LogoMe.91399353.svg";